import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const USER_POST_URL = 'user/posts'

const errors = createHandbookResponseErrors('должность', 'должностей')

export const UserPostApi = createNewHandbookApi(USER_POST_URL, errors)
